import { FAMILY_PROPOSTE_FILTER_CHIPS } from './familyPropostaTaxonomy';
import laSede5Hero from '../images/la-sede-5.jpg';
import ce2024Hero from '../images/ce-2024.jpg';

const landingPagesConfig = {
  'eventi-adulti': {
    slug: 'eventi-adulti',
    title: 'Eventi per adulti',
    subtitle:
      'Socialità serale, cultura leggera e spazi su misura: trova ciò che fa per te, dal primo ingresso.',
    heroImage: {
      src: '/images/network-hero.png',
      alt: 'Eventi e socialità per adulti',
    },
    target:
      'Adulti e giovani adulti che cercano serate fuori routine, incontri conviviali e luoghi dove incontrarsi.',
    primaryCta: {
      label: 'Scopri i prossimi eventi',
      href: '/attivita',
    },
    secondaryCta: {
      label: 'Prenota il tuo posto',
      href: '/contatti',
    },
    identitySection: {
      eyebrow: 'Chi è CIL',
      title:
        'CIL è un presidio culturale di quartiere che crea relazioni reali',
      description:
        'Siamo un’associazione che progetta esperienze sociali e culturali accessibili, con uno stile accogliente e concreto. Per adulti significa trovare luoghi dove stare bene, partecipare e sentirsi parte di una comunità.',
      pillars: [
        'Programmazione continuativa con format chiari',
        'Spazi curati per socialità, cultura e creatività',
        'Community inclusiva, aperta anche ai nuovi ingressi',
      ],
      trustNote:
        'Lavoriamo sul territorio con partner locali e persone volontarie che conoscono davvero i bisogni della comunità.',
    },
    sections: {
      audienceTitle: 'Per chi è',
      intro:
        'Pensiamo a bisogni concreti: uscire, stare in buona compagnia, provare qualcosa di nuovo — senza stress da organizzazione.',
      needsTitle: 'Di cosa hai bisogno?',
      needs: [
        'Socialità e momenti conviviali',
        'Serate fuori dalla routine',
        'Cultura accessibile e divertente',
        'Esperienze diverse dal solito locale',
        'Networking leggero e informale',
      ],
      categoriesTitle: 'Come può aiutarti CIL',
      categories: [
        {
          title: 'Social & Community',
          ideas: [
            'Aperitivi creativi',
            'Serate a tema',
            'Networking informale',
            'Incontri di community',
          ],
        },
        {
          title: 'Cultura & Intrattenimento',
          ideas: [
            'Concerti e musica live',
            'DJ set e serate musicali',
            'Rassegne ed eventi brevi',
            'Eventi culturali',
          ],
        },
        {
          title: 'Esperienze Creative',
          ideas: [
            'Workshop pratici',
            'Laboratori artistici',
            'Scrittura, foto e multimedia',
            'Serate creative hands-on',
            'Percorsi creativi brevi',
          ],
        },
        {
          title: 'Spazi & Formazione',
          highlight: true,
          ideas: [
            'Affitto sala eventi',
            'Coworking creativo',
            'Feste private',
            'Corsi e mini-workshop',
            'Team building aziendali',
          ],
        },
      ],
      valueTitle: 'Perché scegliere CIL',
      valueItems: [
        'Radicamento sul territorio e aperture alla comunità.',
        'Accoglienza chiara: anche al primo ingresso ti orientiamo noi.',
        'Equilibrio tra svago, cultura e cura delle relazioni.',
      ],
      finalCtaTitle: 'Prenota o chiedi informazioni',
      finalCtaText:
        'Scegli una proposta dalla pagina, apri il calendario filtrato per adulti oppure scrivici per affitti e eventi su misura.',
    },
    dynamicContent: {
      events: {
        enabled: true,
        title: 'Prossimi appuntamenti in calendario',
        filters: {
          partecipantiFilter: 'Per Adulti',
        },
      },
      fallback: {
        title: 'Nessun evento disponibile al momento',
        text: 'Stiamo aggiornando la programmazione. Intanto puoi consultare il calendario completo.',
        ctaLabel: 'Vai al calendario',
        ctaHref: '/calendario',
      },
      propostePubbliche: {
        enabled: true,
        landing: 'eventi-adulti',
        title: 'Proposte per adulti',
        subtitle:
          'Serate, laboratori, performance e format pensati per chi cerca qualcosa di più di una serata generica.',
        limit: 10,
        fallbackText: 'Nuove proposte per adulti in arrivo.',
        filtersEnabled: true,
        /** Chip: oltre alle keyword, match su `activity.category` / `experienceType` (allineato alle opzioni admin). */
        filterChips: [
          { key: 'all', label: 'Tutte', keywords: [] },
          {
            key: 'social',
            label: 'Social',
            matchExperienceTypes: ['social'],
            matchCategories: ['evento', 'esperienza', 'corso'],
            keywords: ['aperitiv', 'networking', 'community', 'conviv'],
          },
          {
            key: 'cultura',
            label: 'Cultura',
            matchExperienceTypes: ['culturale', 'musicale'],
            matchCategories: ['rassegna', 'evento', 'corso'],
            keywords: ['concert', 'musica', 'rassegna', 'dj', 'teatro'],
          },
          {
            key: 'creative',
            label: 'Creative',
            matchExperienceTypes: ['creativo'],
            matchCategories: ['laboratorio', 'corso', 'esperienza'],
            keywords: ['workshop', 'laborator', 'foto', 'arte', 'scrittura'],
          },
          {
            key: 'affitto',
            label: 'Spazi e affitti',
            keywords: [
              'affitto',
              'sala',
              'cowork',
              'privat',
              'aziend',
              'festa',
            ],
          },
        ],
      },
    },
  },
  'magic-tcg': {
    slug: 'magic-tcg',
    title: 'Magic & TCG',
    subtitle:
      'Tornei, serate di gioco e community per chi vuole giocare, migliorare e conoscere nuovi player.',
    heroImage: {
      src: laSede5Hero,
      alt: 'Hero Magic e TCG',
    },
    target:
      'Giocatori e giocatrici di Magic e TCG, principianti e esperti, in cerca di eventi e community locale.',
    primaryCta: {
      label: 'Partecipa al prossimo evento',
      href: '/attivita?categoryFilter=MAGIC',
    },
    secondaryCta: {
      label: 'Unisciti alla community',
      href: '/tesseramento',
    },
    identitySection: {
      eyebrow: 'Chi è CIL',
      title: 'CIL è una community dove il gioco è cultura, incontro e crescita',
      description:
        'Per la scena Magic e TCG, CIL è uno spazio affidabile dove giocare con continuità, migliorare il proprio livello e conoscere nuovi player in un clima rispettoso.',
      pillars: [
        'Eventi e serate con format bilanciati per livelli diversi',
        'Attenzione a fair play, onboarding e qualità del tavolo',
        'Community locale attiva, non solo eventi spot',
      ],
      trustNote:
        'Costruiamo appuntamenti ricorrenti e relazioni solide tra giocatori, staff e organizzatori.',
    },
    sections: {
      audienceTitle: 'Per chi è',
      offersTitle: 'Cosa trovi',
      offers: [
        'Tornei e leghe per giocatori di livello diverso.',
        'Serate gioco casual e competitivo.',
        'Introduzione guidata per nuovi giocatori.',
        'Eventi filtrati per categoria Magic/TCG.',
      ],
      valueTitle: 'Valore della community CIL',
      valueItems: [
        'Ambiente aperto, rispettoso e orientato alla crescita.',
        'Supporto ai nuovi ingressi con tutor e tavoli introduttivi.',
        'Programmazione costante con appuntamenti ricorrenti.',
      ],
      finalCtaTitle: 'Entra nel circuito Magic & TCG',
      finalCtaText:
        'Scegli l evento più adatto al tuo livello e inizia a giocare con la community CIL.',
    },
    dynamicContent: {
      events: {
        enabled: true,
        title: 'Eventi Magic e TCG in arrivo',
        filters: {
          categoryFilter: 'MAGIC',
        },
      },
      fallback: {
        title: 'Nessun evento Magic/TCG in calendario',
        text: 'Nuove date in pubblicazione. Controlla il calendario completo o contattaci per info.',
        ctaLabel: 'Esplora attività',
        ctaHref: '/attivita',
      },
      propostePubbliche: {
        enabled: true,
        landing: 'magic-tcg',
        title: 'Proposte Magic & TCG',
        subtitle:
          'Tornei, incontri, percorsi e attività dedicate al gioco organizzato.',
        limit: 6,
        fallbackText: 'Nuove proposte Magic e TCG in arrivo.',
      },
    },
  },
  'proposte-scuole': {
    slug: 'proposte-scuole',
    title: 'Proposte per le scuole',
    subtitle:
      'Percorsi educativi e laboratori progettati con scuole, insegnanti e dirigenti per obiettivi didattici concreti.',
    target:
      'Scuole, insegnanti, dirigenti scolastici e referenti educativi che cercano attività strutturate.',
    primaryCta: {
      label: 'Richiedi una proposta',
      href: '/contattaci',
    },
    secondaryCta: {
      label: 'Scopri le proposte',
      href: '/chi-siamo',
    },
    identitySection: {
      eyebrow: 'Chi è CIL',
      title:
        'CIL è un partner educativo che affianca la scuola con metodo e progettazione',
      description:
        'Siamo un’associazione culturale che trasforma obiettivi didattici in attività concrete, inclusive e sostenibili per classi e docenti.',
      pillars: [
        'Co-progettazione con insegnanti e referenti scolastici',
        'Format laboratoriali replicabili e misurabili',
        'Linguaggio chiaro su tempi, logistica e risultati attesi',
      ],
      trustNote:
        'Ogni proposta nasce per supportare il lavoro della scuola, non per sovrapporsi ad esso.',
    },
    sections: {
      audienceTitle: 'Per chi è',
      offersTitle: 'Cosa trovi',
      offers: [
        'Schede tecniche attività e obiettivi educativi.',
        'Proposte per fasce d età e contesti scolastici diversi.',
        'Indicazioni logistiche e organizzative per classi e gruppi.',
        'Metodo educativo basato su creatività, cooperazione e partecipazione.',
      ],
      valueTitle: 'Approccio educativo CIL',
      valueItems: [
        'Co-progettazione con docenti in base ai bisogni reali.',
        'Format laboratoriali replicabili in classe.',
        'Esperienze inclusive orientate a competenze trasversali.',
      ],
      finalCtaTitle: 'Porta CIL nella tua scuola',
      finalCtaText:
        'Raccontaci il contesto della tua classe: prepariamo una proposta dedicata con obiettivi, tempi e costi.',
    },
    contacts: {
      email: 'info@cilassociazione.it',
      phone: '+39 353 468 2493',
      phoneTel: '+393534682493',
    },
    dynamicContent: {
      events: {
        enabled: false,
      },
      fallback: {
        title: 'Contenuti in aggiornamento',
        text: 'Stiamo strutturando ulteriori materiali tecnici e casi studio. Contattaci per una proposta su misura.',
        ctaLabel: 'Contattaci',
        ctaHref: '/contattaci',
      },
    },
  },
  'proposte-famiglie': {
    slug: 'proposte-famiglie',
    title: 'Proposte per famiglie',
    subtitle:
      'Tempo insieme, sorrisi e piccole avventure: percorsi pensati per genitori e figli, senza complicare la giornata.',
    heroImage: {
      src: ce2024Hero,
      alt: 'Esperienze per famiglie',
    },
    target:
      'Famiglie che vogliono condividere momenti semplici, sicuri e un po’ diversi dal solito weekend.',
    primaryCta: {
      label: 'Contattaci se ci sono cose particolari che vuoi fare!',
      href: '/contatti',
    },
    secondaryCta: null,
    identitySection: {
      eyebrow: 'Chi è CIL',
      title:
        'CIL è un luogo di comunità dove le famiglie trovano tempo di qualità',
      description:
        'Siamo un’associazione che unisce gioco, creatività e relazione in esperienze semplici da vivere insieme. Per le famiglie significa sentirsi accolte, informate e accompagnate.',
      pillars: [
        'Attività pensate per età, tempi e bisogni reali',
        'Contesti sicuri, inclusivi e facili da capire',
        'Esperienze che rafforzano legami tra adulti e ragazzi',
      ],
      trustNote:
        'Mettiamo al centro accessibilità e benessere relazionale, senza complicare l’organizzazione delle famiglie.',
    },
    sections: {
      audienceTitle: 'Per chi è',
      intro:
        'Partiamo dai bisogni reali: stare vicini, divertirsi, uscire un po’ dalla routine — con proposte chiare e accessibili.',
      needsTitle: 'Di cosa hai bisogno?',
      needs: [
        'Passare tempo insieme',
        'Far divertire i ragazzi senza stress',
        'Fare qualcosa di diverso dal solito',
        'Momenti semplici e alla portata di tutti',
        'Weekend e tempo libero organizzato',
      ],
      categoriesTitle: 'Idee e percorsi CIL per la tua famiglia',
      categories: [
        {
          title: 'Esperienze outdoor',
          ideas: [
            'Escursioni ad anello per famiglie',
            'Passeggiate tematiche (natura, storia locale)',
            'Caccia al tesoro nel territorio',
            'Giornate al Munlab',
            'Pic-nic organizzati',
          ],
        },
        {
          title: 'Laboratori e creatività',
          ideas: [
            'Laboratori genitori-figli',
            'Arte e manualità',
            'Costruzione con argilla, legno e materiali naturali',
            'Laboratori stagionali (estate, Natale, Halloween)',
          ],
        },
        {
          title: 'Gioco e socialità',
          ideas: [
            'Pomeriggi giochi da tavolo',
            'Tornei family-friendly',
            'Giochi cooperativi',
            'Incontri ludici e leggeri',
          ],
        },
        {
          title: 'Eventi leggeri',
          ideas: [
            'Feste di comunità',
            'Giornate a tema (fantasy, medievale…)',
            'Mini spettacoli per famiglie',
            'Appuntamenti al parco',
          ],
        },
        {
          title: 'Collaborazioni',
          ideas: [
            'Iniziative con associazioni del territorio',
            'Eventi con scuole e reti educative',
            'Laboratori con artisti e professionisti ospiti',
          ],
        },
      ],
      valueTitle: 'Perché scegliere CIL in famiglia',
      valueItems: [
        'Territorio e comunità: spesso co-progettiamo con realtà locali.',
        'Accoglienza e chiarezza: sai cosa aspettarti prima di prenotare.',
        'Gioco, creatività e relazione, senza retorica “educativa”.',
      ],
      finalCtaTitle: 'Organizza il prossimo momento in CIL',
      finalCtaText:
        'Sfoglia le proposte qui sotto o apri il calendario: prenota con anticipo o scrivici per dubbi su età e accessibilità.',
    },
    dynamicContent: {
      events: {
        enabled: true,
        title: 'Prossimi appuntamenti aperti a tutti',
        filters: {
          partecipantiFilter: 'Per Tutti',
        },
      },
      fallback: {
        title: 'Nessun appuntamento per tutti in evidenza',
        text: 'Nuove date in arrivo: consulta il calendario per gli eventi aperti a tutti.',
        ctaLabel: 'Apri il calendario',
        ctaHref: '/calendario',
      },
      propostePubbliche: {
        enabled: true,
        landing: 'proposte-famiglie',
        title: 'Proposte per famiglie',
        subtitle:
          'Spettacoli, laboratori e momenti da vivere insieme, con schede chiare e obiettivi trasparenti.',
        limit: 10,
        fallbackText: 'Nuove proposte per famiglie in arrivo.',
        filtersEnabled: true,
        /** Chip da `familyPropostaTaxonomy.js` (allineati alle categorie del form admin). */
        filterChips: FAMILY_PROPOSTE_FILTER_CHIPS,
      },
    },
  },
  'proposte-ragazzi': {
    slug: 'proposte-ragazzi',
    title: 'Proposte per ragazzi',
    subtitle:
      'Divertimento, community e cose “serie ma non noiose”: spazi dove stare bene insieme, senza paternalismo.',
    heroImage: {
      src: '/assets/landing-school-ambientazione.jpg',
      alt: 'Percorsi per ragazzi',
    },
    target:
      'Ragazze e ragazzi, con il supporto dei genitori dove serve, che cercano appuntamenti credibili e inclusivi.',
    primaryCta: {
      label: 'Scopri le proposte',
      href: '/attivita?partecipantiFilter=Per%20Ragazzi',
    },
    secondaryCta: {
      label: 'Richiedi informazioni',
      href: '/contattaci',
    },
    identitySection: {
      eyebrow: 'Chi è CIL',
      title:
        'CIL è una community dove ragazze e ragazzi possono essere protagonisti',
      description:
        'Siamo un’associazione culturale che crea spazi credibili per gioco, creatività e socialità, con regole chiare e tono vicino ai giovani.',
      pillars: [
        'Percorsi che valorizzano interessi reali e autonomia',
        'Contesti inclusivi con attenzione al gruppo e al singolo',
        'Mix di attività ludiche, creative e community-driven',
      ],
      trustNote:
        'L’obiettivo è far crescere appartenenza, competenze sociali e fiducia, non proporre attività “calate dall’alto”.',
    },
    sections: {
      audienceTitle: 'Per chi è',
      intro:
        'Ci concentriamo su cosa serve davvero: divertirsi, sentirsi parte di un gruppo, provare esperienze che non sembrano “da piccoli”.',
      needsTitle: 'Di cosa hai bisogno?',
      needs: [
        'Divertirsi e staccare dalla routine',
        'Stare con altri coetanei',
        'Sentirsi parte di qualcosa',
        'Esperienze interessanti, non infantili',
      ],
      categoriesTitle: 'Idee e percorsi CIL',
      categories: [
        {
          title: 'Gioco e community',
          ideas: [
            'Magic: The Gathering e format introduttivi',
            'Tornei e serate gioco',
            'Giochi da tavolo più “strategici”',
            'Serate gaming di gruppo',
          ],
        },
        {
          title: 'Eventi',
          ideas: [
            'Feste e compleanni in spazio CIL',
            'Serate a tema',
            'Cosplay, anime e cultura nerd',
            'Tornei dal vivo',
          ],
        },
        {
          title: 'Esperienze',
          ideas: [
            'Spettacoli interattivi',
            'Teatro partecipativo',
            'Eventi immersivi',
          ],
        },
        {
          title: 'Laboratori',
          ideas: [
            'Multimedia, foto e video',
            'Creatività digitale',
            'Percorsi creativi brevi',
          ],
        },
        {
          title: 'Community',
          ideas: [
            'Gruppi tematici ricorrenti',
            'Club (giochi, fumetti, ecc.)',
            'Appuntamenti fissi di community',
          ],
        },
      ],
      valueTitle: 'Perché la community CIL',
      valueItems: [
        'Territorio e reti giovanili: spesso co-progettiamo con chi ci sta davvero.',
        'Accoglienza chiara: regole e obiettivi trasparenti.',
        'Equilibrio tra gioco, espressione e rispetto delle persone.',
      ],
      finalCtaTitle: 'Entra in un percorso o scrivici',
      finalCtaText:
        'Scegli una proposta qui sotto, controlla il calendario filtrato per ragazzi o mandaci una richiesta per età e interessi.',
    },
    dynamicContent: {
      events: {
        enabled: true,
        title: 'Prossimi appuntamenti in calendario',
        filters: {
          partecipantiFilter: 'Per Ragazzi',
        },
      },
      fallback: {
        title: 'Calendario ragazzi in aggiornamento',
        text: 'Stiamo completando le nuove date. Puoi comunque scriverci per percorsi e disponibilità.',
        ctaLabel: 'Richiedi informazioni',
        ctaHref: '/contattaci',
      },
      propostePubbliche: {
        enabled: true,
        landing: 'proposte-ragazzi',
        title: 'Proposte per ragazzi',
        subtitle:
          'Laboratori, game night, eventi e percorsi pensati per fasce d’età che vogliono autonomia e qualità.',
        limit: 10,
        fallbackText: 'Nuove proposte per ragazzi in arrivo.',
        filtersEnabled: true,
        /** Chip: keyword OR categoria / activityType (form ragazzi–teen). */
        filterChips: [
          { key: 'all', label: 'Tutte', keywords: [] },
          {
            key: 'game',
            label: 'Gioco',
            matchExperienceTypes: ['gioco'],
            matchCategories: ['torneo'],
            matchActivityTypes: ['gaming'],
            keywords: [
              'magic',
              'torneo',
              'tavolo',
              'gaming',
              'gioch',
              'commander',
            ],
          },
          {
            key: 'eventi',
            label: 'Eventi',
            matchCategories: ['evento', 'esperienza', 'rassegna'],
            matchActivityTypes: ['evento', 'spettacolo'],
            keywords: [
              'festa',
              'compleann',
              'cosplay',
              'anime',
              'tema',
              'immersiv',
            ],
          },
          {
            key: 'lab',
            label: 'Laboratori',
            matchCategories: ['laboratorio', 'corso'],
            matchActivityTypes: ['creativo'],
            keywords: ['laborator', 'foto', 'video', 'multimedia', 'digital'],
          },
          {
            key: 'community',
            label: 'Community',
            matchExperienceTypes: ['social'],
            matchCategories: ['corso', 'esperienza'],
            keywords: ['club', 'grupp', 'ricorrent', 'community'],
          },
        ],
      },
    },
  },
};

export const landingSlugs = Object.keys(landingPagesConfig);

/**
 * Landing standalone: ordine fisso, solo path root delle pagine (no sotto-route).
 * Titoli allineati a `landingPagesConfig` dove esiste.
 */
export const LANDING_NAV_ITEMS = [
  { path: '/proposte-scuole', title: 'Proposte per le scuole' },
  {
    path: '/eventi-adulti',
    title: landingPagesConfig['eventi-adulti'].title,
  },
  {
    path: '/magic-tcg',
    title: landingPagesConfig['magic-tcg'].title,
  },
  {
    path: '/proposte-famiglie',
    title: landingPagesConfig['proposte-famiglie'].title,
  },
  {
    path: '/proposte-ragazzi',
    title: landingPagesConfig['proposte-ragazzi'].title,
  },
];

/** Sottomenu voce Attività (solo landing proposte). */
export const ATTIVITA_NAV_ITEMS = [...LANDING_NAV_ITEMS];

const resolveLandingBasePath = (pathname = '') => {
  if (!pathname) return null;
  if (
    pathname === '/richiesta-scuole' ||
    pathname.startsWith('/proposte-scuole')
  ) {
    return '/proposte-scuole';
  }
  if (pathname.startsWith('/eventi-adulti')) return '/eventi-adulti';
  if (pathname.startsWith('/magic-tcg')) return '/magic-tcg';
  if (pathname.startsWith('/proposte-famiglie')) return '/proposte-famiglie';
  if (pathname.startsWith('/proposte-ragazzi')) return '/proposte-ragazzi';
  return null;
};

/** Titolo landing (header) coerente con `LANDING_NAV_ITEMS` / config. */
export const getStandaloneLandingTitle = (pathname = '') => {
  const base = resolveLandingBasePath(pathname);
  if (!base) return '';
  return LANDING_NAV_ITEMS.find((item) => item.path === base)?.title || '';
};

/** Link alle altre landing root (esclude la base della pagina corrente). */
export const getOtherLandingNavItems = (pathname) => {
  const base = resolveLandingBasePath(pathname);
  if (!base) return [];
  return LANDING_NAV_ITEMS.filter((item) => item.path !== base);
};

/** Evidenzia la voce menu Attività sulle landing proposte. */
export const isAttivitaMenuActive = (pathname = '') =>
  Boolean(resolveLandingBasePath(pathname));

export default landingPagesConfig;
